module.exports = __webpack_public_path__ + "img/img-40.4f8a48a7.png";